import { ref } from 'vue'
import { normalizeToastMessage } from '@/utils/errorUtils.js'

const toasts = ref([])

export function useToast() {
  const addToast = (message, type = 'success', duration = 5000) => {
    const id = Date.now()
    const toast = {
      id,
      message: normalizeToastMessage(message),
      type,
      timeoutId: null,
      isPaused: false
    }
    
    toasts.value.push(toast)
    
    if (type !== 'loading') {
      startToastTimer(toast, duration)
    }

    return toast.id
  }

  const startToastTimer = (toast, duration) => {
    if (toast.isPaused || toast.type === 'loading') return

    toast.timeoutId = setTimeout(() => {
      removeToast(toast.id)
    }, duration)
  }

  const pauseToast = (id) => {
    const toast = toasts.value.find(t => t.id === id)
    if (toast && toast.type !== 'loading') {
      toast.isPaused = true
      clearTimeout(toast.timeoutId)
    }
  }

  const resumeToast = (id, duration = 3000) => {
    const toast = toasts.value.find(t => t.id === id)
    if (toast && toast.type !== 'loading') {
      toast.isPaused = false
      startToastTimer(toast, duration)
    }
  }

  const removeToast = (id) => {
    const index = toasts.value.findIndex(toast => toast.id === id)
    if (index > -1) {
      clearTimeout(toasts.value[index].timeoutId)
      toasts.value.splice(index, 1)
    }
  }

  const updateToast = (id, message) => {
    const toast = toasts.value.find(t => t.id === id)
    if (toast) {
      toast.message = normalizeToastMessage(message)
    }
  }

  return {
    toasts,
    addToast,
    removeToast,
    pauseToast,
    resumeToast,
    updateToast
  }
} 